/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NamirasoftCredentialServer } from "./NamirasoftCredentialServer";
import { NamirasoftCredentialServerBase } from "./NamirasoftCredentialServerBase";

export class NamirasoftCredentialServerValue extends NamirasoftCredentialServerBase
{
    constructor(server: NamirasoftCredentialServer)
    {
        super(server);
        this.List = this.List.bind(this);
    }
    async List(table: string, column: string, search: (string | null), field_id: (string | null), limit: (number | null)): Promise<string[]>
    {
        let path = `/value/list/${table}/${column}`;
        let { data } = await this.server._get<string[]>(path, { search, field_id, limit });
        return data;
    }
};